import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useBackend } from "../backend/BackendProvider";

const ROOT_ATTRIBUTES = ["data-theme", "data-density", "data-reduce-motion"] as const;

export function PreferenceEffects() {
  const backend = useBackend();
  const preferences = useQuery({ queryKey: ["preferences"], queryFn: () => backend.preferences.get() });

  useEffect(() => {
    if (!preferences.data) return;
    const root = document.documentElement;
    root.dataset.theme = preferences.data.theme;
    root.dataset.density = preferences.data.density;
    root.dataset.reduceMotion = preferences.data.reduceMotion ? "true" : "false";
    root.style.colorScheme = preferences.data.theme === "system" ? "light dark" : preferences.data.theme;
  }, [preferences.data]);

  useEffect(() => () => {
    const root = document.documentElement;
    for (const attribute of ROOT_ATTRIBUTES) root.removeAttribute(attribute);
    root.style.removeProperty("color-scheme");
  }, []);

  return null;
}
